import React, { useState } from "react";
import { Key } from "lucide-react";
import { Button } from "@/layouts/AuthLayout/ui/Button";
import { loginWithPasskey, supportsPasskeys } from "./lib/passkeys";


interface Props {
  email?: string;
  onSuccess: (token: string) => void;
  onError: (msg: string) => void;
  disabled?: boolean;
}

const PassKeyLogin: React.FC<Props> = ({
  email,
  onSuccess,
  onError,
  disabled = false,
}) => {
  const [loading, setLoading] = useState(false);

  const handlePasskeyLogin = async () => {
    if (!supportsPasskeys()) {
      onError("Passkeys are not supported on this device/browser");
      return;
    }

    setLoading(true);

    try {
      const result = await loginWithPasskey(email || "");

      if (!result?.token) {
        throw new Error("Passkey login failed");
      }

      onSuccess(result.token);
    } catch (err: any) {
      onError(err.message || "Passkey login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handlePasskeyLogin}
      loading={loading}
      disabled={disabled}
      icon={<Key className="w-5 h-5" />}
      fullWidth
      className="bg-black text-white hover:bg-gray-900"
    >
      Sign in with Passkey
    </Button>
  );
};

export default PassKeyLogin;